import styles from './how-to-apply-title.module.scss';

type Props = {
  headline: string;
  icon: JSX.Element;
};

export default function HowToApplyTitle({ headline, icon }: Props) {
  return (
    <h3 className={`d-flex align-items-end ${styles.hta_title}`}>
      {icon}
      <span>{headline}</span>
    </h3>
  );
}
